/** This component is recalled in share-contribution component */
import { QrCodePublicComponent } from './../qr-code-public/qr-code-public.component';
import { Component, Input, OnInit } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatDialog } from '@angular/material/dialog';
import { CustomDomainService } from 'src/app/global/services/custom-domain.service';
import { TabChangeRequestService } from 'src/app/pages/fundraiser/services/tab-switch.service';
import { ShareModule } from 'ngx-sharebuttons';
import { MatButtonModule } from '@angular/material/button';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { FlexModule } from '@angular/flex-layout/flex';
import { NgIf, NgClass, NgStyle } from '@angular/common';
/**
 * DESCRIPTION: Share buttons component for fundraisers
 * EXAMPLE: facebook, twitter, linkedin, whatsapp, email, copy url
 * TODO: Use API from ngx-sharebutton to add functionality for meta tag like title, descritption. This is helpfull when this component want to override the metatag of page.
 */
@Component({
	selector: 'app-social-share-buttons',
	templateUrl: './social-share-buttons.component.html',
	styleUrls: ['./social-share-buttons.component.scss'],
	standalone: true,
	imports: [
		NgIf,
		FlexModule,
		NgClass,
		ExtendedModule,
		MatButtonModule,
		ShareModule,
		NgStyle,
	],
})
export class SocialShareButtonsComponent implements OnInit {
	@Input() componentCalled: any;
	@Input() sharedLink: string = '';
	@Input() disableSocialShare: boolean = false;
	@Input() tabRoute: boolean = false;
	@Input() isDonationModule: boolean = false;
	@Input() customURL: string = '';
	@Input() currentFundraiserData: any;
	@Input() showLabels: boolean = false;
	@Input() fundraiserDetails: any;
	constructor(
		public media: MediaObserver,
		public dialog: MatDialog,
		public tabchangerequest: TabChangeRequestService,
		public customDomainService: CustomDomainService
	) {}
	ngOnInit(): void {
		this.customURL = window.location.href;

		this.customDomainService.getIsCustomDomain().subscribe((res: any) => {
			if (res == true) {
				this.customURL = window.location.href;
			}
		});
	}

	openQrDialog(): void {
		const dialogRef = this.dialog.open(QrCodePublicComponent, {
			panelClass: 'share-dialog-panel',
			maxHeight: 'auto',
			maxWidth: '90vw',
			width: '95vw',
			data: { link: this.sharedLink, details: this.fundraiserDetails },
		});
	}

	onTabChange() {
		if (
			this.componentCalled === 'fundraiser' ||
			this.componentCalled === 'donate'
		) {
			this.tabchangerequest.changeTab('ownWebsite');
		} else {
			this.tabchangerequest.changeTab('');
		}
	}

	shareToFacebook(): void {
		const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
			this.customURL
		)}`;

		// Open the share dialog in a new window
		window.open(facebookShareUrl, '_blank');
	}
}
